export default __webpack_public_path__ + "68b1f12c86e3cdd5ed85aa8a93d0cd7e.png";